import React, { useState } from 'react';

const InterventionReportForm = () => {
  const [problemType, setProblemType] = useState('');
  const [detailedDescription, setDetailedDescription] = useState('');
  const [needAnotherIntervention, setNeedAnotherIntervention] = useState('');
  const apiUrl = 'https://lebontechnicien.net'
    
  const techCloseRequest = async (e) => {
    e.preventDefault();
    if (needAnotherIntervention === 'Oui') {
      console.log('Besoin dune autre intervention');
      //setCreationDevisModal(true);
    } else {
      // Fermeture d'une demande côté technicien
      try {
        const response = await fetch(
          `${apiUrl}/temp/tech_close_request`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
            body: JSON.stringify({
              email: sessionStorage.getItem("email"),
              id: sessionStorage.getItem("id"),
              //rid: id,
              problemType: problemType,
              detailedDescription: detailedDescription,
              needAnotherIntervention: needAnotherIntervention,
            }),
          }
        );
  
        const data = await response.json();
        //navigate(`/user-history`);
      } catch (error) {
        console.error(error);
      }
    }
  };
  



  return (
    <div className="fixed inset-0 z-10 flex items-center justify-center bg-black bg-opacity-50" onClick={'handleTeh'}>
      <div className="bg-white w-full max-w-lg p-4 rounded-md shadow-lg">
        <h2 className="text-lg font-bold mb-4">Rapport d'Intervention</h2>
        <form onSubmit={techCloseRequest}>
          <div className="mb-4">
            <label className="block font-bold mb-1" htmlFor="problemType">
              Type de problème:
            </label>
            <input
              type="text"
              id="problemType"
              value={problemType}
              onChange={(e) => setProblemType(e.target.value)}
              required
              className="w-full border p-2"
            />
          </div>

          <div className="mb-4">
            <label className="block font-bold mb-1" htmlFor="detailedDescription">
              Description détaillée de l'intervention et du problème:
            </label>
            <textarea
              id="detailedDescription"
              value={detailedDescription}
              onChange={(e) => setDetailedDescription(e.target.value)}
              required
              className="w-full border p-2"
            />
          </div>

          <div className="mb-4">
            <label className="block font-bold mb-1">
              Besoin d'une autre intervention:
            </label>
            <div>
              <label className="mr-4">
                <input
                  type="radio"
                  name="needIntervention"
                  value="Oui"
                  checked={needAnotherIntervention === 'Oui'}
                  onChange={(e) => setNeedAnotherIntervention(e.target.value)}
                  className="mr-2"
                />
                Oui
              </label>
              <label>
                <input
                  type="radio"
                  name="needIntervention"
                  value="Non"
                  checked={needAnotherIntervention === 'Non'}
                  onChange={(e) => setNeedAnotherIntervention(e.target.value)}
                  className="mr-2"
                />
                Non
              </label>
            </div>
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-blue-500 text-white font-bold py-2 px-4 rounded"
            >
              {needAnotherIntervention === 'Oui' ? 'Next' : 'Envoyer le rapport'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default InterventionReportForm;
